import { combineReducers } from "redux";

import authReducer from "./features/auth/authSlice";

import notificationStoreReducer from "./features/notification/notificationSlice";

import dateFilterReducer from "./features/dateFilter/dateFilterSlice";
import customSnackbarReducer from "./features/customSnackbar/customSnackbarSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  dateFilter: dateFilterReducer,
  notification: notificationStoreReducer,
  customSnackbar:customSnackbarReducer,
});

export default rootReducer;
